/*
 * @Author: mzw
 * @Date: 2025-04-10 10:40:11
 * @LastEditTime: 2025-04-10 10:40:11
 * @LastEditors: mzw
 * @Description: AI工具的开场白
 */
export const prologue_materialAssistant = `你好，我是Plantmart智慧物料助手，可以为你提供物料描述再规则化、划分类目、推荐商品、参数诊断等功能，很高兴为您服务。
输入示例：可调温焊锡锅   ms-100 ∮100*40mm”
输出内容样式示例：

输入物料信息"XXXX"信息分析整理如下：
商品分类：一级分类>二级分类>三级分类
物料名称：
品牌名称：
型号：
规格：
单位：
数量：
目标价：
推荐商品：SSFWG0004BE（推荐分值：34.0）

参数诊断：
缺失率：
具体情况如下，
|属性名称|命中参数值|近似参数值|
|--|--|--|
|产品执行标准|IEC289：1987电抗器|执行器|
|-|-|-|`

export const prologue_sourceAssistant = `可以参考以下口令输入方法使用自定义提示词完成相应处理，如果不输入则使用默认提示词进行处理，直接输入物料需求信息即可
* * *
提示词：搜索物料的价格、供应商信息、联系人以及联系方式、返回对应的网页链接或者产品链接,并按照价格升序排列整合内容形成表格输出，文本部分详情放在中间，最后给出采购建议
物料：外六角螺栓 DIN933全牙/M20-2.5*85/A2-70/304`
export const copyText_sourceAssistant = `提示词：搜索物料的价格、供应商信息、联系人以及联系方式、返回对应的网页链接或者产品链接,并按照价格升序排列整合内容形成表格输出，文本部分详情放在中间，最后给出采购建议
物料：外六角螺栓 DIN933全牙/M20-2.5*85/A2-70/304`